module.exports = __webpack_public_path__ + "img/20191129165037378.f0c4873d.jpg";